<template>
    <div class="mx-auto">
        <b-row class="mb-0">
            <b>Pesquisa pelo Número da Requisição: </b>
            <i class="fas fa-info-circle fa-12x text-info ml-2" variant="info"
               v-b-popover.hover.top="'Exibirá, como resultado, apenas a Requisição pesquisada.'"
               title="Pesquisa pelo número da Requisição"></i>
        </b-row>
        <b-row>
            <b-col sm="12" md="4">
                <b-form-group
                        label="Informe o Número da Requisição:"
                        label-for="numeroRequisicao"
                        class="text-label">
                    <b-form-input
                            ref="numeroRequisicao"
                            type="text"
                            id="numeroRequisicao"
                            v-model="filtros.numeroRequisicao"
                            v-mask="['#########']"
                            class="numeroRequisicao"
                            description="Somente os números"
                    ></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

        <hr class="mt-4"/>

        <b-row class="mb-0">
            <b>Pesquisa pelo Número de Processo ou CDA:</b>
            <i class="fas fa-info-circle fa-12x text-info ml-2" variant="info"
               v-b-popover.hover.top="'Exibirá, como resultado, todas as Requisições geradas para o processo judicial ou CDA pesquisado.'"
               title="Pesquisa pelo Número de Processo ou CDA"></i>
        </b-row>
        <b-row>
            <b-col sm="12" md="4">
                <b-form-group
                        label="Informe o Número CNJ:"
                        label-for="cnj"
                        class="text-label">
                    <b-form-input
                            type="text"
                            id="cnj"
                            v-model="filtros.cnj"
                            @focus="filtros.cda = ''"
                            v-mask="['#######-##.####.#.##.####']"
                            description="Somente os números"
                            @change="completarCnj();"
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4">
                <b-form-group
                        label="Informe o Número da CDA:"
                        label-for="cnj"
                        class="text-label">
                    <b-form-input
                            type="text"
                            id="cda"
                            v-model="filtros.cda"
                            v-mask="['###########']"
                            @focus="filtros.cnj = ''"
                            description="Somente os números"
                    ></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

        <hr class="mt-4"/>

        <b-row class="mb-0">
            <b>Pesquisa por Devedor:</b>
            <i class="fas fa-info-circle fa-12x text-info ml-2" variant="info"
               v-b-popover.hover.top="'Exibirá, como resultado, todas as Requisições geradas para o devedor pessoa física ou pessoa jurídica pesquisado.'"
               title="Pesquisa por Devedor"></i>
        </b-row>
        <b-row>
            <b-col md="2">
                <b-form-group
                        label="CPF / CNPJ do Devedor:"
                        label-for="cpf"
                        class="text-label">
                    <b-form-input
                            type="text"
                            ref="numDocumento"
                            id="num-documento"
                            data-vv-as="CPF"
                            v-model="filtros.cpfCnpj"
                            v-mask="['XX.XXX.XXX', 'XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-##']"
                            @change="buscarDevedor"
                            :class="!validations.documento.valid ? 'is-invalid' : ''"
                    ></b-form-input>
                    <span v-if="!validations.documento.valid" class="invalid-message">{{validations.documento.mensagem}}</span>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group
                        label="Nome / Razão Social do Devedor:"
                        label-for="devedor"
                        class="text-label" >
                    <vue-suggestion :items="devedores"
                                    v-model="filtros.nomeDevedor"
                                    :setLabel="setLabel"
                                    :itemTemplate="itemTemplate"
                                    :inputClasses="'form-control'"
                                    :minLen="3"
                                    @changed="inputChange"
                                    @blur="inputBlur"
                                    @selected="itemSelected"
                                    @enter="acaoEnter">
                    </vue-suggestion>
                </b-form-group>
            </b-col>
	        <b-col md="2" class="mt-4" style="margin-left: -15px;">
                <b-button
                    tabindex="-1"
                    class="icon-button"
                    title="Abrir Cadastro do Devedor"
                    variant="outline-primary"
                    :disabled="!validations.documento.valid || (filtros.cpfCnpj == null || filtros.cpfCnpj == '')"
                    @click="abrirModalDevedor()">
                    <i class="far fa-address-book fa-flip-horizontal vertical-middle"></i>
                </b-button>
                <b-button
                    tabindex="-1"
                    class="icon-button btn-documentos"
                    title="Documentação do Devedor"
                    variant="outline-primary"
                    :disabled="filtros.cpfCnpj == null || (filtros.cpfCnpj.length !== 14 && filtros.cpfCnpj.length !== 18)"
                    @click="abrirModalDocumentosDevedor()">
                    <i class="far fa-copy fa-flip-horizontal vertical-middle"></i>
                </b-button>
            </b-col>
        </b-row>

        <hr class="mt-4"/>

        <b-row class="mb-0">
            <b>Pesquisa Requisições emitidas num período determinado:</b>
            <i class="fas fa-info-circle fa-12x text-info ml-2" variant="info"
               v-b-popover.hover.top="'Exibirá, como resultado, todas as Requisições geradas no sistema no período pesquisado, de todos os devedores e de todos os processos.'"
               title="Pesquisa Requisições emitidas num período determinado"></i>
        </b-row>
        <b-row>
            <b-col md="2">
                <label>
                    Data de Início:
                </label>
                <b-input id="dataInicio" v-model="filtros.dataInicio" :max="maxDate" type="date" placeholder></b-input>
            </b-col>
            <b-col md="2">
                <label>
                    Data Final:
                </label>
                <b-input class="dataFinal" v-model="filtros.dataFinal" :max="maxDate" type="date" placeholder></b-input>
            </b-col>
        </b-row>
        <CompLoading ref="loading"/>

	    <ModalIncluirDevedor ref="modalDevedor"
	                         @novoDevedor="salvarDevedor" />

	    <ModalAlterarDevedor
		    ref="modalAlterarDevedor"
		    :loading="$refs.loading"
		    @salvarDevedor="salvarDevedor"/>

        <ModalDocumentosDevedor ref="modalDocumentosDevedor"
                                :loading="$refs.loading"/>
    </div>
</template>

<script>
    import axios from 'axios';
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompLoading from "../../shared/components/CompLoading";
    import itemTemplate from './item-template.vue';
    import ModalDocumentosDevedor from "../../shared/components/ModalDocumentosDevedor";
    import ModalIncluirDevedor from "../../shared/components/ModalIncluirDevedor";
    import ModalAlterarDevedor from "../../shared/components/ModalAlterarDevedor";

    export default {
        props: ['filtros'],
        mixins: [ formatarMixins ],
        components: {ModalAlterarDevedor, ModalIncluirDevedor, ModalDocumentosDevedor, CompLoading},
        data() {
            return {
                urlApi: null,
                token: null,
                maxDate: null,
                devedor: {
	                documento: null
                },
                devedores: [],
                itemTemplate,
                validations: {
                    documento: {
                        valid: true,
                        mensagem: ''
                    }
                }
            }
        },
        methods: {
            itemSelected (item) {
                this.devedor = item;
                this.filtros.nomeDevedor = item.nome;

                if(item.cpf && item.cpf != '') {
                    this.devedor.documento = item.cpf;
                    this.filtros.cpfCnpj = this.mascaraCpf(item.cpf);
                } else {
                    this.devedor.documento = item.cnpj;
                    this.filtros.cpfCnpj = this.mascaraCnpj(item.cnpj);
                }

            },
            inputBlur (item) {
                this.filtros.nomeDevedor = {nome: item};
            },
            setLabel (item) {
                return item.nome;
            },
            inputChange (text) {
                this.devedor = null;
                if(text != null && text.length >= 3) {
                    axios.post(`${this.urlApi}/v1/contribuinte/consultar?page=1&sortField=contribuinte.nome&sortOrder=asc`, {nome: text}, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                    }).then(response => {
                        this.devedores = response.data.resultado;
                    })
                }
            },
            async buscarDevedor() {
                this.devedor = null;
                if(this.filtros.cpfCnpj != null && this.filtros.cpfCnpj.length > 0) {
                    this.$store.commit("setMessages", {});
                    this.filtros.nomeDevedor = {id: 0, nome: ''};

                    this.validations.documento.valid = true;
                    if (this.filtros.cpfCnpj.length !== 10) {
                        if (this.filtros.cpfCnpj.length <= 14 && !this.validarCpf(this.filtros.cpfCnpj)) {
                            this.validations.documento.valid = false;
                            this.validations.documento.mensagem = 'CPF inválido.';
                            return;
                        } else if (this.filtros.cpfCnpj.length > 14 && !this.validarCnpjAlfanumerico(this.filtros.cpfCnpj)) {
                            this.validations.documento.valid = false;
                            this.validations.documento.mensagem = 'CNPJ inválido.';
                            return;
                        }
                    }

                    let devedor = {
                        documento: this.filtros.cpfCnpj
                    };

                    this.$refs.loading.showLoading();
                    axios.post(`${this.urlApi}/v1/receitasDiversas/obterContribuinte`, devedor, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                    }).then(response => {
                        if(response.data != null && response.data != "") {
                            this.devedor = response.data;
                            this.filtros.nomeDevedor = {id: 0, nome: response.data.nome};
                        }
                    }).finally(() => {
                        this.$refs.loading.hideLoading();
                    });
                }
            },
            acaoEnter() {
				if(!this.$refs.modalDevedor.isShow()
		            && !this.$refs.modalAlterarDevedor.isShow()
		            && !this.$refs.modalDocumentosDevedor.isShow()) {
					document.getElementById("btnProxima").click();
				}
            },
            completarCnj() {
                if (this.filtros.cnj != '' && this.onlyNumber(this.filtros.cnj).length < 20) {
                    this.filtros.cnj = this.mascaraCnj(this.onlyNumber(this.filtros.cnj).padStart(20, '0'));
                }
            },
	        abrirModalDevedor() {
		        if(this.devedor && this.devedor.codContribuinte) {
			        this.$refs.modalAlterarDevedor.carregarCadastro(this.devedor.codContribuinte);
		        } else {
			        this.$refs.modalDevedor.abrirModalIncluirDevedorComDados({
				        documento: this.filtros.cpfCnpj
			        });
		        }
	        },
	        salvarDevedor(contribuinte) {
		        this.devedor = contribuinte;
		        this.filtros.cpfCnpj = this.devedor.documento;
		        this.filtros.nomeDevedor = {id: 0, nome: this.devedor.nome};
	        },
	        abrirModalDocumentosDevedor () {
                document.activeElement.blur()

                let documento
                let codContribuinte
                if (this.devedor) {
                    documento = this.devedor.documento
                    codContribuinte = this.devedor.codContribuinte
                } else {
                    documento = ''
                    codContribuinte = ''
                }

                this.$refs['modalDocumentosDevedor'].abrirModal(documento, codContribuinte)
            },
	        acaoEnterCompleta (e) {
		        if(e.key == 'Enter') {
			        if(document.activeElement.id == 'dataInicio') {
				        document.getElementsByClassName('dataFinal')[0].focus();
			        } else {
				        setTimeout(()=>{
					        document.getElementsByClassName('numeroRequisicao')[0].focus();
					        this.acaoEnter();
				        }, 0);
			        }
		        }
            },
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            var dataAtual = new Date();
            let ano = dataAtual.getFullYear();
            let mes = dataAtual.getMonth() + 1;
            this.maxDate = ano + "-" + (mes < 10 ? "0" : "") + mes + "-" + (dataAtual.getDate() < 10 ? "0" : "") + dataAtual.getDate();

            setTimeout(()=>{
                document.getElementsByClassName('numeroRequisicao')[0].focus();
            }, 500);

            window.addEventListener("keypress", this.acaoEnterCompleta);
        }
    }
</script>
<style scoped>
    .vue-suggestion .vs__list {
        width: 100%;
        text-align: left;
        border: none;
        border-top: none;
        max-height: 400px;
        overflow-y: auto;
        border-bottom: 1px solid #023d7b;
        position: relative;
        z-index: 10;
    }
    .vue-suggestion .vs__list .vs__list-item {
        background-color: #fff;
        padding: 10px;
        border-left: 1px solid #023d7b;
        border-right: 1px solid #023d7b;
    }
    .vue-suggestion .vs__list .vs__list-item:last-child {
        border-bottom: none;
    }
    .vue-suggestion .vs__list .vs__list-item:hover {
        background-color: #eee !important;
    }
    .vue-suggestion .vs__list,
    .vue-suggestion .vs__loading {
        position: absolute;
    }
    .vue-suggestion .vs__list .vs__list-item {
        cursor: pointer;
    }
    .vue-suggestion .vs__list .vs__list-item.vs__item-active {
        background-color: #f3f6fa;
    }

	.icon-button {
		font-size: 1.5rem;
		margin-left: 1rem;
		padding: 0 0.5rem;
	}

	.vertical-middle {
		vertical-align: middle;
	}
</style>